module.exports = __webpack_public_path__ + "img/bg_general-group-seating-3.c983f1e2.jpeg";